<template>
  <div class="home">
    <div v-html="tableau" id=""></div>
  </div>
</template>
<script>
import { fileDownload } from "@/api/user";
import XLSX from "xlsx";
export default {
  name: "previewWord",
  data() {
    return {
      tableau: null,
    };
  },
  props: {
    pdfFile: {
      type: Object,
      default: () => {},
    },
    funcs: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    async getPdfUrl(file) {
      let res = await fileDownload(file.url.split("=")[1], "xls");
      const workbook = XLSX.read(new Uint8Array(res.data), {
        type: "array",
      }); // 解析数据
      const worksheet = workbook.Sheets[workbook.SheetNames[0]]; // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
      this.tableau = XLSX.utils.sheet_to_html(worksheet); // 渲染
      console.log("this.tableau", this.tableau);
    },
  },
  watch: {
      pdfFile: {
          handler(file) {
              console.log(file, 'pppp');
            let _this = this
            if (file) {
                _this.getPdfUrl(file)
            }
          },
          deep: true,
          immediate: true
      }
  },
};
</script>  

<style lang="scss" scoped>
// .viewItemFile {
.image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    height: 600px;
    width: 600px;
  }
}
.divContent {
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/ .el-dialog__body {
  height: 96%;
  width: 100%;
  padding: 0;
  overflow: auto;
}
// }
// .viewItemFile {
/deep/ table {
  width: 100% !important;
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  text-align: center !important;
  border: 1px !important;
  overflow-x: auto !important;
  border-left: 1px solid gray !important;
  border-top: 1px solid gray !important;
}

/deep/ table tr td {
  /* border: 1px solid gray !important; */
  border-right: 1px solid gray !important;
  border-bottom: 1px solid gray !important;
  width: 300px !important;
  height: 33px !important;
}
/**整体样式 */
/deep/ .excel-view-container {
  background-color: #ffffff;
}
/**标题样式 */
/deep/ .class4Title {
  font-size: 22px !important;
  font-weight: bold !important;
  padding: 10px !important;
}
/**表格表头样式 */
/deep/ .class4TableTh {
  /* font-size: 14px !important; */
  font-weight: bold !important;
  padding: 2px !important;
  background-color: #ccc !important;
}
// }
</style>
<style lang="scss">
// .viewItemFileDialog {
//   overflow: hidden;
.el-dialog__header {
  padding: 10px 20px 10px;
  // background-color: #19a199;
}
.el-dialog__header .el-dialog__title {
  font-size: 15px;
  // color: #ffffff;
  font-weight: 700;
}
.search-btn {
  background: #19a8a6;
  color: white;
  border: none;
  height: 30px;
  padding: 0px 20px;
}
.well {
  display: block;
  background-color: #f2f2f2;
  border: 1px solid #ccc;
  margin: 0px;
  width: 100%;
  height: 100%;
  overflow: auto;
}
// }
</style>